import { Injectable } from '@angular/core';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { BOToothQuote } from '../models/odo/BOToothQuote.model';


pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable({
  providedIn: 'root'
})
export class PdfService {

  constructor() {}

  // generateExternalPDF(quote: BOToothQuote, getDocumentDefinitionExternal: (q: BOToothQuote) => any) {
  //   const documentDefinition = getDocumentDefinitionExternal(quote);
  //   pdfMake.createPdf(documentDefinition).open();
  // }

  generateExternalPDF(documentDefinition: any) {
  pdfMake.createPdf(documentDefinition).open();
}
}
